export default {
    black: '#000000',
    'darkest-grey': '#202020',
    'darker-grey': '#404040',
    'dark-grey': '#606060',
    grey: {
        base: '#9e9e9e',
        lighten5: '#fafafa',
        lighten4: '#f5f5f5',
        lighten3: '#eeeeee',
        lighten2: '#e0e0e0',
        lighten1: '#bdbdbd',
        darken1: '#757575',
        darken2: '#616161',
        darken3: '#424242',
        darken4: '#212121'
    },
    'lightest-grey': '#E0E0E0',
    'lighter-grey': '#C0C0C0',
    'light-grey': '#A0A0A0',
    white: '#FFFFFF'
}
